/* eslint-disable */

import api from '../request/api'

export default {
  namespaced: true,
  state: {
    provinceList: [],
    gameProjectList: [],
    groupedGameProjects: [], // 新增的用于存储分组数据
    sharedData: {
      pid: 790,
      cid: 24,
      area_id: -1,
      page: 1,
      limit: 5
    },
    allowLineLisy: [],
    loading: true,
    shoppingCartList: []
  },
  mutations: {
    setProvinceList(state, data) {
      state.provinceList = [{ name: '全部地区', id: -1 }, ...data];
    },
    setGameProjectList(state, data) {
      state.gameProjectList = data;
      // 归类游戏项目
      state.groupedGameProjects = groupByInitials(data);
    },
    setGroupedGameProjects(state, groupedData) {
      state.groupedGameProjects = groupedData;
    },
    setSharedData(state, data) {
      const mapping = {
        pid: 'id',
        cid: 'cid',
        area_id: 'id'
      };
      // if (data.stype == 'pid') {
      //   state.sharedData.area_id = -1
      // }
      const field = mapping[data.stype];
      if (field) {
        state.sharedData[data.stype] = data[field];
      }
      // console.log('ss:', data);
      // console.log('ss2:', state.sharedData);

    },
    setallowLine(state, data) {
      // state.allowLineLisy = [...state.allowLineLisy, ...data]
      state.allowLineLisy = data.map(item => ({
        ...item,
        value: 0
      }));
      state.loading = false
      console.log('ss:', state.allowLineLisy)
    },
    // 删除 shoppingCartList 中的 item
    removeAllowLine(state, item) {
      const index = state.shoppingCartList.findIndex(i => i.id == item.id); // 根据 id 查找索引
      if (index !== -1) {
        state.shoppingCartList.splice(index, 1); // 删除该项
      } else {
        console.log('未找到该项，无法删除:', item);
      }
    },

    // 更新 shoppingCartList 中的 item，如果没有该项，则添加
    updateAllowLine(state, updatedItem) {
      const index = state.shoppingCartList.findIndex(item => item.id == updatedItem.id);
      if (index != -1) {
        state.shoppingCartList.splice(index, 1, updatedItem); // 更新该项
      } else {
        // 如果没有该项，直接添加到购物车列表
        state.shoppingCartList.push(updatedItem);
      }
    },
    emptyAllowLine(state, updatedItem) {
      // 清空购物车
      state.shoppingCartList.forEach(item => {
        item.value = 0;
      });
      state.shoppingCartList = [];  // 清空数组
    }
  },
  actions: {
    async getStaticArea({ commit }) {
      try {
        let res = await api.getStaticArea({pageSize:1000});

        console.log('获取省份列表:', res);

        if (res.code == 1) {
          commit('setProvinceList', res.data);
        }
      } catch (error) {
        console.error('获取省份列表失败:', error);
      }
    },
    async getGameProject({ commit }) {
      try {
        let res = await api.getGameProject();
        if (res.code == 1) {
          commit('setGameProjectList', res.data);
        }
      } catch (error) {
        console.error('获取游戏项目失败:', error);
      }
    },
    updateSharedData({ commit }, data) {
      commit('setSharedData', data);  // 触发 mutation 更新数据
    },
    async getEffectiveStaticLines({ commit, state }) {
      state.loading = true
      try {
        let res = await api.getEffectiveStaticLines(state.sharedData)
        if (res.code == 1) {
          commit('setallowLine', res.data);  // 触发 mutation 更新数据
        }
      } catch (error) {
        console.error('获取可以购买的线路失败:', error);
      }
    }
  }
};

// 分组函数
function groupByInitials(projects) {
  return projects.reduce((acc, project) => {
    const firstLetter = project.initials.toUpperCase(); // 获取首字母并转为大写
    if (!acc[firstLetter]) {
      acc[firstLetter] = [];
    }
    acc[firstLetter].push(project); // 按首字母分组
    return acc;
  }, {});
}
